module.exports = __webpack_public_path__ + "pc/img/career-swiper01.49091c5d.webp";